const btnObj = {
  customClass: {
    container: 'swalBox',
    popup: 'swalBox_popup',
    header: 'swalBox_header',
    title: 'swalBox_title',
    closeButton: 'swalBox_btnClose',
    icon: 'swalBox_icon',
    image: 'swalBox_image',
    content: 'swalBox_content',
    input: 'swalBox_input',
    actions: 'swalBox_actions',
    confirmButton: 'swalBox_btnConfirm',
    cancelButton: 'swalBox_btnCancel',
    footer: 'swalBox_footer'
  },
  confirmButtonColor: '#074f7e',
  cancelButtonColor: '#8b0301',
  cancelButtonText: 'Voltar',
  confirmButtonText: 'Confirmar',
}

const objSwal = {
  question: {
    ...btnObj,
    title: '',
    text: '',
    // type: 'question',
    type: '',
    showCancelButton: true,
    reverseButtons: true
  },
  warning: {
    ...btnObj,
    title: '',
    text: '',
    // type: 'warning',
    type: '',
    confirmButtonText: 'Continua'
  },
  success: {
    ...btnObj,
    title: '',
    text: '',
    // type: 'success',
    type: '',
    confirmButtonText: 'Continuar'
  },
  error: {
    ...btnObj,
    title: '',
    text: '',
    // type: 'error',
    type: '',
    confirmButtonText: 'Fechar'
  },
  info: {
    ...btnObj,
    title: '',
    text: '',
    // type: 'info',
    type: '',
    confirmButtonText: 'Continuar'
  },
}

export default objSwal
